<section class="loading" [class.active]="loadingService.active">
  <div class="bg-blur"></div>
  <div class="loading-spinner">
    <div class="loading-spinner__circle loading-spinner__circle--one"></div>
    <div class="loading-spinner__circle loading-spinner__circle--two"></div>
    <div class="loading-spinner__circle loading-spinner__circle--three"></div>
    <div class="loading-spinner__circle loading-spinner__circle--four"></div>
  </div>
</section>
